import './static/styles/_all.scss';

import { ADMIN_SERVICES_NAMESPACE } from './constants';
import AdminRoutes from './routes';
import { CachesService } from './services/cachesService';
import { MaintenanceService } from './services/maintenanceService';
import { AdminModule } from './store';

const moduleName = 'admin';

/**
 * Function to install module in Vue instance
 * @params {Object} Vue: Vue instance
 * @params {Object} settings: object who contains router and store instance
 * */
export function install(Vue, settings) {
  if (!settings || !settings.store || !settings.router) {
    throw new Error('Please initialise plugin with a Vuex store and a Vue router.');
  }
  settings.router.addRoutes(AdminRoutes);
  settings.store.registerModule(moduleName, AdminModule);

  function addNamespacedService(serviceName, service) {
    return settings.services.addNamespacedService(ADMIN_SERVICES_NAMESPACE, serviceName, service);
  }

  addNamespacedService('cachesService', new CachesService());
  addNamespacedService('maintenanceService', new MaintenanceService());
}

export default install;
